<script>
import bannerImg from '@/assets/images/responsive/home-banner.jpg?min=768&max=3200';
import bannerMobileImg from '@/assets/images/responsive/home-banner-mobile.jpg?min=320&max=768';
import BuyerButton from '@/components/Button';
import ResponsiveImage from '@/components/ResponsiveImage';
import LinkButton from '@/components/LinkButton';

export default {
  components: {
    BuyerButton,
    LinkButton,
    ResponsiveImage,
  },
  data: () => ({
    bannerImg,
    bannerMobileImg,
  }),
};
</script>

<template lang='pug'>
.relative.max-w-10xl.mx-auto.mt-3.lg_mt-4.xl_mt-5
  responsive-image.md_hidden(
    v-if='["sm", "md"].includes($mq)'
    sizes='(min-width: 769px) 0px, 100vw',
    :image-object='bannerMobileImg',
    alt-text='Planning to sell your designs on ViralStyle?'
  )
  responsive-image.hidden.md_block(
    v-else,
    sizes='(min-width: 768px) 100vw, 0px',
    :image-object='bannerImg',
    alt-text='Planning to sell your designs on ViralStyle?'
  )
  .absolute.absolute--center.flex.justify-center.items-center.px-1.flex-wrap.text-center.w-full
    .text-4xl.md_text-xl.text-white.font-bold.tracking-wide.px-1.md_p-0.md_mr-2.my-1.lg_mr-3 Planning to sell your designs on ViralStyle?
    buyer-button.mr-2.my-1.lg_mr-3(
      text='JOIN NOW',
      @click.native='$router.push({ name: "signUp" })',
      @keyup.enter.native='$router.push({ name: "signUp" })',
    )
    link-button.my-1(
      text='HOW IT WORKS',
      @click='$router.push({ name: "openShop" })',
    )
</template>

<style>
@import '~import/index';
</style>